/**
 * Made-up email and Instagram conversations for the Conversations preview tabs
 * (LEAD-6, REM-2, REM-3, open questions Q17 and Q18). Every person, address and
 * message is invented; the pages that show them carry a PreviewBanner. Senders
 * with `leadEmail` match a lead in the local demo seed.
 */

export type InboxChannel = 'email' | 'instagram';

export type InboxMessage = {
  id: string;
  from: string;
  fromTeam: boolean;
  /** The bot's short answer: a draft waits for a team member to confirm it (REM-2). */
  bot?: 'draft' | 'sent';
  text: string;
  sentAt: string;
};

export type InboxStatus = 'needs_reply' | 'new_lead' | 'answered';

export type InboxThread = {
  id: string;
  channel: InboxChannel;
  subject?: string;
  /** The sender's address: an email, or an Instagram @handle. */
  contact: string;
  name: string;
  /** Set when the sender is a known lead. */
  leadEmail?: string;
  status: InboxStatus;
  messages: InboxMessage[];
};

export const MOCK_INSTAGRAM_THREADS: InboxThread[] = [
  {
    id: 'ig-1',
    channel: 'instagram',
    contact: '@casino.dreams.br',
    name: 'Casino Dreams',
    status: 'new_lead',
    messages: [
      { id: 'ig-1-1', from: 'casino.dreams.br', fromTeam: false, text: 'Oi! How much does it cost to start my own casino?', sentAt: '2026-10-27T05:20:00Z' },
      { id: 'ig-1-2', from: 'Prisma bot', fromTeam: true, bot: 'draft', text: 'Thanks for writing! A team member will send you the plans. Which email can they use?', sentAt: '2026-10-27T05:21:00Z' },
    ],
  },
  {
    id: 'ig-2',
    channel: 'instagram',
    contact: '@alexnovak.crypto',
    name: 'Alex Novak',
    leadEmail: 'cryptoalex@example.com',
    status: 'needs_reply',
    messages: [
      { id: 'ig-2-1', from: 'alexnovak.crypto', fromTeam: false, text: 'Do you support USDT deposits and withdrawals?', sentAt: '2026-10-26T21:47:00Z' },
      { id: 'ig-2-2', from: 'Prisma bot', fromTeam: true, bot: 'draft', text: 'Yes, crypto payments are supported. A team member will confirm which coins and networks.', sentAt: '2026-10-26T21:48:00Z' },
    ],
  },
  {
    id: 'ig-3',
    channel: 'instagram',
    contact: '@jonas.luckypartners',
    name: 'Jonas Berg',
    leadEmail: 'partners@luckypartners.example',
    status: 'answered',
    messages: [
      { id: 'ig-3-1', from: 'jonas.luckypartners', fromTeam: false, text: 'Can we move our call to Thursday?', sentAt: '2026-10-24T14:02:00Z' },
      { id: 'ig-3-2', from: 'Sara Ionescu', fromTeam: true, text: 'Sure, Thursday at 15:00 CET works. I sent a new invite.', sentAt: '2026-10-24T14:30:00Z' },
    ],
  },
];
